"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formControlState;
function formControlState(param) {
    let { props, states, muiFormControl } = param;
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') {
                acc[state] = muiFormControl[state];
            }
        }
        return acc;
    }, {});
}
